import * as React from 'react';
import * as dayjs from 'dayjs';
import { getHour, getMinute, newDateTimeValue } from '../logic/util/DateTime';
import BaseComponent from './BaseComponent';
import pathToUpdate from 'src/logic/type/pathToUpdate';

interface Props {
  title: string;
  dateTime: number;
  isActive: boolean;
  handleModalActive: Function;
  handleUpdateRecord: Function;
  pathToUpdate: pathToUpdate;
}
interface State {
  dateTime: number;
}

class TimeSelecter extends BaseComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      dateTime: props.dateTime
    };
  }

  handleClose = () => {
    this.props.handleModalActive();
  };

  handleOnChangeSelect = (
    event: React.FormEvent<HTMLSelectElement>,
    unitType: dayjs.UnitType
  ) => {
    const value = event.currentTarget.value;
    const newDateTime = newDateTimeValue(
      this.state.dateTime,
      unitType,
      Number(value)
    );
    this.setState({
      dateTime: newDateTime
    });
  };

  handleOnSave = () => {
    const { handleUpdateRecord, pathToUpdate } = this.props;
    handleUpdateRecord(pathToUpdate, this.state.dateTime);
    this.handleClose();
  };

  render() {
    const { title, isActive } = this.props;
    const { dateTime } = this.state;
    return (
      <div className={`modal ${isActive ? 'is-active' : ''}`}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">{title}</p>
            <button
              className="delete"
              aria-label="close"
              onClick={this.handleClose}
            />
          </header>
          <section className="modal-card-body">
            <div className="field has-addons">
              <p className="control">
                <span className="select">
                  <select
                    value={getHour(dateTime)}
                    onChange={e => this.handleOnChangeSelect(e, 'hour')}
                  >
                    {hh.map((item, index) => (
                      <option value={item} key={`${index}+${item}`}>
                        {item}時
                      </option>
                    ))}
                  </select>
                </span>
                <span className="select">
                  <select
                    value={getMinute(dateTime)}
                    onChange={e => this.handleOnChangeSelect(e, 'minute')}
                  >
                    {mm.map((item, index) => (
                      <option value={item} key={`${index}+${item}`}>
                        {item}分
                      </option>
                    ))}
                  </select>
                </span>
              </p>
            </div>
          </section>
          <footer className="modal-card-foot">
            <button className="button is-success" onClick={this.handleOnSave}>
              Save changes
            </button>
            <button className="button" onClick={this.handleClose}>
              Cancel
            </button>
          </footer>
        </div>
        <button className="modal-close is-large" aria-label="close" />
      </div>
    );
  }
}

const hh = [
  '00',
  '01',
  '02',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23'
];

const mm = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59'
];

export default TimeSelecter;



// WEBPACK FOOTER //
// ./src/components/TimeSelecter.tsx